import { styled } from 'styled-components';
import { fadeInKeyframes } from '@inter-ikea-guida/framework';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
const StyledForm = styled.div `
  animation: ${fadeInKeyframes} ${props => (props.$shouldAnimate ? '0.5s' : 0)} ease-in;
`;
const StyledToggleGroup = styled.div `
  margin-bottom: 1rem;
`;
const StyledSelectContainer = styled.div `
  display: ${props => (props.$show ? 'block' : 'none')};
`;
const StyledSelect = styled.div `
  margin-bottom: ${SkapaTokens.space100};
`;
export { StyledForm, StyledToggleGroup, StyledSelect, StyledSelectContainer };
//# sourceMappingURL=styles.js.map